module.exports = __webpack_public_path__ + "static/dusanstvo_otebe-527e0a4bdcbd78c1b93fee62ce3dc9d6.jpg";